import React from "react";
import { Icon } from "../comp/Icon";
import { getStyleObject, renameExtension } from "../_global";

export class LayerIcon extends React.Component {
    constructor(props) {
        super(props);

        this.remove = this.remove.bind(this);
        this.up = this.up.bind(this);
        this.down = this.down.bind(this);
        this.select = this.select.bind(this);
        this.hide = this.hide.bind(this);
    }

    remove(e) {
        this.props.remove(this.props.index);
        e.stopPropagation();
    }

    up(e) {
        this.props.up(this.props.index);
        e.stopPropagation();
    }

    down(e) {
        this.props.down(this.props.index);
        e.stopPropagation();
    }

    select() {
        this.props.select(this.props.index);
    }

    hide(e) {
        this.props.edit(this.props.index, "hidden", !this.props.info.hidden);
        e.stopPropagation();
    }


    render() {

        // edit image


        return (
            <div 
                className={(this.props.active) ? "layer-icon active" : "layer-icon"}
                onClick={this.select}
            >
                <div className="buttons">
                    <button onClick={this.remove}> <Icon type="fa-remove" /> </button>
                    <button onClick={this.up}> <Icon type="fa-chevron-up" /> </button>
                    <button onClick={this.down}> <Icon type="fa-chevron-down" /> </button>
                </div>

                <div className={(this.props.info.hidden) ? "icon hidden" : "icon"} onClick={this.hide}>
                    <img 
                        src={"./img/" + this.props.info.collection + "/" + this.props.section + "/" + this.props.info.item + ".png"} 
                        alt={this.props.info.item}
                        style={getStyleObject(this.props.info, 40, 1)}
                        draggable="false"
                    />
                </div>

                <span className="label">
                    {this.props.info.item}{renameExtension(this.props.section)}
                    {" "}

                    <span className="small">
                        {(this.props.info.scale == 1) ? "" : "(" + this.props.info.scale + "x)"}
                    </span>
                </span>
            </div>
        );
    }
}


LayerIcon.defaultProps = {
    active: false
};
